import { MdOutlineSmartphone, MdRestaurant } from "react-icons/md";
import { PiClockCountdownBold, PiVideoCameraFill } from "react-icons/pi";

export const priceSegments: Map<number, { min: number; max?: number }> = new Map([
  [0, { min: 1, max: 10 }],
  [1, { min: 10, max: 20 }],
  [2, { min: 20, max: 30 }],
  [3, { min: 30, max: 40 }],
  [4, { min: 40, max: 50 }],
  [5, { min: 50, max: 60 }],
  [6, { min: 60, max: 70 }],
  [7, { min: 70, max: 80 }],
  [8, { min: 80, max: 90 }],
  [9, { min: 90, max: 100 }],
  [10, { min: 100 }],
]);

export const PARTNERS = { italylunch: 53467 };

export const GUIDELINES = [
  {
    Icon: MdOutlineSmartphone,
    titleKey: "guidelines.format",
    labelKey: "guidelines.mobilePortrait",
  },
  {
    Icon: PiClockCountdownBold,
    titleKey: "guidelines.duration",
    labelKey: "guidelines.videoDuration",
  },
  {
    Icon: PiVideoCameraFill,
    titleKey: "guidelines.videoContent",
    labelKey: "guidelines.noPhotos",
  },
  {
    Icon: MdRestaurant,
    titleKey: "guidelines.subject",
    labelKey: "guidelines.frameDishAndEnvironment",
  },
];
